module.exports = __webpack_public_path__ + "img/logo-white.6c8007e2.png";